import API from 'services/TAPS_API';

export default function getParentTaxAuthority(taxCode) {
  return API.request({
    method: 'GET',
    url: `/dictionary/findParentTaxAuthority?taxCode=${taxCode}`,
  });
}
